import {ListUnorderedIcon} from '@primer/octicons-react'
import {IconButton, type ButtonProps, type IconButtonProps} from '@primer/react'
import {clsx} from 'clsx'
import React from 'react'

export interface FileTreeToggleButtonProps extends Pick<ButtonProps, 'variant'> {
  expanded?: boolean
  onToggleExpanded: React.MouseEventHandler<HTMLButtonElement>
  ariaLabel: string
  ariaControls: string
  className?: string
  size?: ButtonProps['size']
  tooltipDirection?: IconButtonProps['tooltipDirection']
  ref?: React.Ref<HTMLButtonElement>
}

export const FileTreeToggleButton = ({
  ref,
  expanded,
  ariaLabel,
  ariaControls,
  onToggleExpanded,
  className,
  size,
  tooltipDirection,
  variant,
}: FileTreeToggleButtonProps) => (
  <IconButton
    aria-label={ariaLabel}
    tooltipDirection={tooltipDirection}
    ref={ref}
    data-testid="file-tree-button"
    data-dd-action-name="pull_request.file_tree.toggle"
    aria-expanded={expanded}
    aria-controls={ariaControls}
    icon={ListUnorderedIcon}
    onClick={onToggleExpanded}
    variant={variant ?? 'invisible'}
    size={size}
    className={clsx(className, 'fgColor-muted')}
  />
)

FileTreeToggleButton.displayName = 'FileTreeToggleButton'
